import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import _ from 'lodash'
import { Button } from '@shopify/polaris'

import { fontSize } from 'components/styles'
import * as shopifyWizardActions from 'constants/shopifyWizardActions'
import ShopifyAssetsSelector from './shopifyUI/ShopifyAssetsSelector'
import CustomizeLogoDesc from './shopifyUI/CustomizeLogoDesc'
import ShopifyCrop from './shopifyUI/ShopifyCrop'
import EditText from './shopifyUI/EditText'
import UICard from './shopifyUI/UICard'
import ShopifyScenesDashboard from './shopifyUI/ShopifyScenesDashboard'
import ShopifyScenesDashboardNew from './shopifyUI/ShopifyScenesDashboardNew'
import * as shopifyAppSceneId from 'constants/shopifyAppSceneId'
import UploadAssetsButton from 'components/editor/assetsManager/UploadAssetsButton'
import { POSITION, ZOOM } from 'constants/stylePresetType'
import { updateCustomStyleEffect, setCustomFieldArray } from 'controllers/logic'
import { publishAndActivate } from 'controllers/shopifyApp'
import { changeEditorScene } from 'actions/locationAC'
import { setShopifyBarTitle } from 'controllers/shopifyBar'

const EditorContainer = styled.div`
  ${fontSize}
  margin-top: 2em;
  margin-right: 2em;
  max-width: 64em;
  height: 100%;

  & .Polaris-Card {
    max-height: calc(100% - 4em);
    display: flex;
    flex-direction: column;
  }

  & .Polaris-Card__Section {
    display: flex;
    flex-direction: column;
    flex-grow: 10;
  }
`
const ContentContainer = styled.div`
  margin-top: 1em;
  display: flex;
`
const FooterLeft = styled.div`
`
const FooterRight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const ButtonContainer = styled.div`
  margin-right: 1em
`

class ShopifyAppEditor extends Component {

  componentDidMount () {
    const { field } = this.props
    this.processShopifyBarTitle(field)
  }

  processShopifyBarTitle (field) {
    let shopifyBarTitle = _.get(field, 'shopifyBarTitle')
    if (_.isNil(shopifyBarTitle)) shopifyBarTitle = _.get(field, 'shopifyBarTitle', '')
    setShopifyBarTitle(shopifyBarTitle)
  }

  componentWillReceiveProps (nextProps) {
    const { location } = this.props
    const sceneNumChanged = location.sceneNum !== nextProps.location.sceneNum
    if (sceneNumChanged) {
      this.processShopifyBarTitle(nextProps.field)
    }
  }

  shopifyCropMounted = ref => {
    this.shopifyCrop = ref
  }

  onCropResizeDone = (path, url) => {
    const { dispatch, app } = this.props
    dispatch(setCustomFieldArray(app.id, path, url))
  }

  renderContent = () => {
    const {
      app,
      customizedSettings,
      apps,
      template,
      field,
      handleSceneChange,
      startProductsSlideWizard,
      onTextFieldFocus
    } = this.props
    switch (field.action) {
      case shopifyWizardActions.CHANGE_IMAGE:
        return (
          <ContentContainer>
            <ShopifyAssetsSelector
              isVideo={false}
              currentValue={_.get(app.customFields, field.paths[0]) || _.get(customizedSettings, field.paths[0])}
              assets={_.has(app, 'assets') ? app.assets : {}}
              path={field.paths[0]}
              apps={apps}
              appId={app.id}
            />
          </ContentContainer>
        )
      case shopifyWizardActions.EDIT_TEXT:
        return (
          <ContentContainer>
            <EditText
              paths={field.paths}
              labels={field.labels}
              app={app}
              template={template}
              onTextFieldFocus={onTextFieldFocus}
            />
          </ContentContainer>
        )
      case shopifyWizardActions.CROP:
        return (
          <ContentContainer>
            <ShopifyCrop
              file={_.get(app.customFields, field.paths[0], '')}
              ref={this.shopifyCropMounted}
              path={field.paths[0]}
              assets={_.has(app, 'assets') ? app.assets : {}}
              appId={app.id}
              previewEltId={field.previewEltId}
              onCropResizeDone={this.onCropResizeDone}
            />
          </ContentContainer>
        )
      case shopifyWizardActions.SCENES_DASHBOARD:
        return (
          <ContentContainer>
            <ShopifyScenesDashboard
              field={field}
              customizedSettings={customizedSettings}
              handleSceneChange={handleSceneChange}
              app={app}
              startProductsSlideWizard={startProductsSlideWizard}
            />
          </ContentContainer>
        )
    }
  }



  onUploadAssetsClick = (e) => {
    if (this.uploadAssetsButtonRef) this.uploadAssetsButtonRef.getWrappedInstance().onClick()
  }

  uploadAssetsButtonMounted = (ref) => {
    this.uploadAssetsButtonRef = ref
  }

  resetPositionZoom = () => {
    const { dispatch, app, field } = this.props
    dispatch(updateCustomStyleEffect(app, field.className, POSITION, null))
    dispatch(updateCustomStyleEffect(app, field.className, ZOOM, null))
  }

  actionsByField = () => {
    const { app, field } = this.props
    const res = []
    switch (field.action) {
      case shopifyWizardActions.CHANGE_IMAGE:
        const uploadButton = (
          <UploadAssetsButton
            ref={this.uploadAssetsButtonMounted}
            appId={app.id}
            isVideo={false}
            useCropModal={false}
          >
            Upload Image
          </UploadAssetsButton>
        )
        res.push({content: uploadButton, onClick: this.onUploadAssetsClick})
        break
      case shopifyWizardActions.CROP:
        res.push({content: 'Change Image', onClick: this.onBack})
        break
    }
    return res
  }

  onNext = () => {
    const { dispatch, location, field } = this.props
    if (field.action === shopifyWizardActions.CROP && this.shopifyCrop) {
      this.shopifyCrop.getWrappedInstance().apply()
    }
    const nextTo = _.get(field, 'nextTo')
    if (nextTo) {
      dispatch(changeEditorScene(location.sceneNum + nextTo.sceneInc))
    } else {
      this.props.goNext()
    }
  }

  onFooterButtonClick = () => {
    const { app, field } = this.props
    switch (field.action) {
      case shopifyWizardActions.PUBLISH:
        this.props.dispatch(publishAndActivate(app.id))
        break
      default:
        this.onNext()
    }
  }

  onBack = () => {
    console.log('onBack')
    const { dispatch, location, field } = this.props
    const backTo = _.get(field, 'backTo')
    console.log('onBack backTo:', backTo, 'current sceneNum', location.sceneNum, 'to', (location.sceneNum + backTo.sceneInc))
    dispatch(changeEditorScene(location.sceneNum + backTo.sceneInc, backTo.menuIndex))
  }

  renderBackButton () {
    const { field } = this.props
    const backTo = _.get(field, 'backTo')
    if (backTo) {
      return (
        <ButtonContainer>
          <Button
            size='slim'
            onClick={this.onBack}
          >
            {_.get(backTo, 'title', 'Back')}
          </Button>
        </ButtonContainer>
      )
    }
  }

  onLeftFooterButtonClick = (additional) => {
    return () => {
      const { dispatch, location } = this.props
      console.log('changeEditorScene: sceneInc', additional.sceneInc, 'menuIndex', additional.menuIndex)
      dispatch(changeEditorScene(location.sceneNum + additional.sceneInc, additional.menuIndex))
    }
  }

  renderLeftFooterPart () {
    const { field } = this.props
    switch (field.action) {
      case shopifyWizardActions.MOVE_RESIZE:
        return (
          <FooterLeft>
            <Button size='slim' plain onClick={this.resetPositionZoom}>
              Undo changes
            </Button>
          </FooterLeft>
        )
      default:
        if (_.has(field, 'additional.title')) {
          const title = field.additional.title
          return (
            <Button size='slim' plain onClick={this.onLeftFooterButtonClick(field.additional)}>{title}</Button>
          )
        } else {
          return <FooterLeft />
        }
    }
  }

  renderRightFooterPart () {
    const { field } = this.props
    return (
      <FooterRight>
        {this.renderBackButton()}
        <Button
          primary
          onClick={this.onFooterButtonClick}
          size='slim'
          disabled={field && field.id === shopifyAppSceneId.PRODUCTS_SCENES_DASHBOARD_EMPTY}
        >
          {_.get(field, 'nextTo.title', 'Next')}
        </Button>
      </FooterRight>
    )
  }

  renderUIUniversal () {
    const { field } = this.props
    return (
      <UICard
        title={_.get(field, 'title')}
        actions={this.actionsByField()}
        description={_.get(field, 'description')}
        content={this.renderContent()}
        footerLeft={this.renderLeftFooterPart()}
        footerRight={this.renderRightFooterPart()}
        height={field.height}
        width={field.width}
        top={field.top}
      />
    )
  }

  renderUI () {
    const { field, goNext, switchSceneToNext, handleSceneChange, app, startAddCollection, editShowcaseIdx } = this.props
    switch (field.id) {
      case shopifyAppSceneId.CUSTOMIZE_LOGO_DESC:
        return <CustomizeLogoDesc goNext={goNext} switchSceneToNext={switchSceneToNext} />
      case shopifyAppSceneId.PRODUCTS_SCENES_DASHBOARD_NEW:
        return (
          <ShopifyScenesDashboardNew
            field={field}
            handleSceneChange={handleSceneChange}
            app={app}
            startAddCollection={startAddCollection}
            editShowcaseIdx={editShowcaseIdx}
          />
        )
      default:
        return this.renderUIUniversal()
    }
  }


  render () {
    return (
      <EditorContainer>
        {this.renderUI()}
      </EditorContainer>
    )
  }
}

ShopifyAppEditor.propTypes = {
  app: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  goNext: PropTypes.func.isRequired,
  switchSceneToNext: PropTypes.func.isRequired,
  customizedSettings: PropTypes.object.isRequired,
  apps: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  template: PropTypes.object.isRequired,
  handleSceneChange: PropTypes.func.isRequired,
  startProductsSlideWizard: PropTypes.func.isRequired,
  onTextFieldFocus: PropTypes.func.isRequired,
  startAddCollection: PropTypes.func.isRequired,
  editShowcaseIdx: PropTypes.number
}

const mapStateToProps = (state) => ({
  apps: state.apps,
  location: state.location
})

export default connect(mapStateToProps)(ShopifyAppEditor)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/ShopifyAppEditor.js